module.exports = __webpack_public_path__ + "img/avatar-four.878e75fb.png";